import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FileService } from '../../services/file.service';
import { HttpClient } from "@angular/common/http";
import * as  JSZip from 'jszip';
import * as JSZipUtil from 'jszip-utils'
import { saveAs } from "file-saver";
import * as _ from 'lodash';
import { MaterialService } from 'src/app/services/material.service';
import { MatSnackBar } from '@angular/material';




@Component({
  selector: 'app-learner-reading-material',
  templateUrl: './learner-reading-material.component.html',
  styleUrls: ['./learner-reading-material.component.scss']
})
export class LearnerReadingMaterialComponent implements OnInit {

  material;
  loadingMaterials: Boolean;
  fileList = [];
  fileListLength;
  loading: boolean = false;
  disableDownloadBtn: boolean;
  fileExtensionArray = ['ppt', 'zip', 'pptx', 'mp4', 'xls', 'xlsx', 'txt', 'odt', 'png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'];
  downloadProgress = 0;
  showProgressbar: boolean = false;
  previousIndex;

  noFile = {
    title: "No Files!",
    data: "Not added any reading materials yet"
  }

  @Output() fileDetailsComp: EventEmitter<any> = new EventEmitter<any>();
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();


  constructor(private _http: HttpClient, private activatedRoute: ActivatedRoute, private router: Router, private _fileService: FileService, private _materialService: MaterialService, public _snackBar: MatSnackBar) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
        this.material = this.router.getCurrentNavigation().extras.state.material;
      }
    });
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(param => {
      console.log("param");
      if (param['id']) {
        console.log("this.material id is", param['id']);
        this.loadingMaterials = true;
        this.getMaterial(param['id'])
      }
      else {
        this.loadingMaterials = true;
        console.log("Materials", this.material)
        this.getMaterialFiles();
      }
    })
  }

  // File Extension Function Here

  FileExtension(extension) {
    let index = _.findIndex(this.fileExtensionArray, function (o) { return o == extension; });
    if (index >= 0) {
      return this.fileExtensionArray[index];
    } else {
      return 'default-extension';
    }
  }


  getMaterialFiles() {
    this._fileService.getFilesByMaterial(this.material._id).subscribe((files) => {
      console.log("FILES", files)
      this.fileList = files;
      this.loadingMaterials = false;
      console.log("this.filesList", this.fileList)
      this.fileListLength = this.fileList.length;
      this.disableDownloadBtn = this.fileListLength > 0 ? false : true;
      console.log('File List Length:', this.fileListLength);
    })
  }


  downloadAll() {

    this.showProgressbar = true;
    this.openSnackBar("Download will begin automaically!", 'OK')

    let tempFolder = this.material.title;
    let tempFileList = this.fileList;
    let zip: JSZip = new JSZip();
    let zipFilename = tempFolder + '.zip';
    let count = 0;
    let download = 0;
    let myZip;

    let percent = 100 / tempFileList.length;
    new JSZip.external.Promise((resolve, reject) => {
      console.log('Download all clicked');
      _.forEach(tempFileList, (file) => {
        let filename = file.path.split("/")[3];
        JSZipUtil.getBinaryContent(file.path, {
          progress(e) {
            let percent_complete = (e.loaded / e.total) * 100;
          }
        }).then((e) => {
          download = download + percent;
          this.downloadProgress = download;
          zip.file(filename, e, { binary: true });
          count++;
          if (count == tempFileList.length) {
            zip.generateAsync({ type: 'blob' }).then((content) => {
              saveAs(content, zipFilename);
              this.showProgressbar = false;
            });
          }
        })
      });
    }).then((data) => {
      console.log("After download completion", data);
    })
  }

  fileDetails(event) {
    this.openFilesSideNav.emit({ event })
    console.log("event in material-tile", event);
    this.previousIndex = event.index
  }

  getMaterial(id) {
    this._materialService.getMaterial(id).subscribe(res => {
      console.log("res ===>>>", res);
      this.material = res[0]
      this.getMaterialFiles()
    })
  }

  clicked(event) {
    this.openSnackBar("Download will begin automaically!", 'OK')
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }
}

